(() => {
  let ticking = false;

  function updateHeroes() {
    document
      .querySelectorAll(
        ".hero-banner--full .hero__media"
      )
      .forEach((media) => {
        const hero = media.closest(".hero__inner");
        if (!hero) return;

        const rect = hero.getBoundingClientRect();

        if (
          rect.bottom < 0 ||
          rect.top > window.innerHeight
        ) {
          return;
        }

        const heroCentre =
          rect.top + rect.height / 2;
        const screenCentre =
          window.innerHeight / 2;

        let movement =
          (screenCentre - heroCentre) * 0.06;

        movement = Math.max(
          -30,
          Math.min(30, movement)
        );

        media.style.setProperty(
          "--muzdan-parallax-y",
          `${movement}px`
        );
      });

    ticking = false;
  }

  function requestUpdate() {
    if (ticking) return;

    ticking = true;
    requestAnimationFrame(updateHeroes);
  }

  window.addEventListener(
    "scroll",
    requestUpdate,
    { passive: true }
  );

  window.addEventListener(
    "resize",
    requestUpdate
  );

  document.addEventListener(
    "shopify:section:load",
    requestUpdate
  );

  updateHeroes();
})();